<template lang="pug">
    div Redirecting...
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			updated: false,
			user: null,
		};
	},

	apollo: {
		user: {
			query: gql`
				{
					User {
						id
						is_organisation_admin
					}
				}
			`,
			update: (r) => r.User,
		},
	},

	watch: {
		user() {
			if (this.updated == false) {
				if (this.user.is_contact) {
					this.$router.push({
						name: "accounts",
						query: this.$route.query,
					});
				} else if (this.user.is_organisation_admin) {
					this.$router.push({
						name: "organisation",
						query: this.$route.query,
					});
				} else {
					this.$router.push({
						name: "dashboard",
						query: this.$route.query,
					});
				}
				this.updated = true;
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/views/pages/IndexRedirect.vue